import React from 'react';
import { ArrowRight } from 'lucide-react';
import { whatIsImageMap } from '../../data/serviceImages';
import DecorativeImage from '../DecorativeImage';

const SDWhatIsSection = ({ content, serviceSlug, onOpenModal }) => {
  const whatIsImage = whatIsImageMap[serviceSlug] || 'https://images.unsplash.com/photo-1589330694653-ded6df03f754?q=80&w=2070';

  return (
    <section className="py-24 bg-[#F9F8F6]" data-testid="sd-what-is-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">

          {/* Left — Image */}
          <div data-testid="sd-what-is-image">
            <DecorativeImage src={whatIsImage} alt={content.title} />
          </div>

          {/* Right — Heading + Paragraph + Button */}
          <div data-testid="sd-what-is-content">
            <p className="eyebrow mb-4">About This Service</p>
            <h2 className="font-display text-4xl md:text-5xl font-bold text-[#111C16] tracking-tighter leading-tight mb-4">
              {content.whatIsTitle}
            </h2>
            <h3 className="font-display text-lg font-semibold text-[#C85A40] mb-6">Your Brand's Legal Shield</h3>
            <p className="font-body text-base text-[#4A5D53] leading-relaxed mb-6">
              {content.whatIsContent}
            </p>
            <button
              onClick={() => onOpenModal?.(`Get Started - ${content.title}`)}
              className="bg-[#C85A40] hover:bg-[#A64730] text-white font-body font-medium px-8 py-4 rounded-full transition-colors flex items-center gap-2"
              data-testid="sd-what-is-cta-button"
            >
              Register Your Trademark
              <ArrowRight className="h-4 w-4" strokeWidth={1.5} />
            </button>
          </div>

        </div>
      </div>
    </section>
  );
};

export default SDWhatIsSection;
